import { LoadingContext } from 'context/corporatiu/LoadingProvider';

import { useContext } from 'react';

export const useLoading = () => {
    const { setIsActiveLoading, activeLoading, skeletonLoading } = useContext(LoadingContext);

    return { setIsActiveLoading, activeLoading, skeletonLoading };
};
